"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _dropdown = _interopRequireDefault(require("./dropdown"));
var _spinner = _interopRequireDefault(require("../spinner"));
var _styles = _interopRequireDefault(require("./styles.scss"));
function Button(props) {
  var children = props.children,
    className = props.className,
    buttonType = props.buttonType,
    variant = props.variant,
    menuClassName = props.menuClassName;
  var icon = props.icon;

  // determine button type
  var inferredButtonType = buttonType;
  if (icon) {
    inferredButtonType = 'icon';
  }
  // support font awesome classname as icon
  if (typeof icon === 'string') {
    icon = /*#__PURE__*/_react.default.createElement("i", {
      className: icon
    });
  }
  var renderButton = function renderButton() {
    switch (inferredButtonType) {
      case 'icon':
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "".concat(_styles.default['icon-button'], " ").concat(className)
        }, /*#__PURE__*/_react.default.createElement(_IconButton.default, props, icon));
      case 'loading':
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "".concat(_styles.default.button, " ").concat(className)
        }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, props, {
          variant: "contained",
          disableElevation: true
        }), /*#__PURE__*/_react.default.createElement("span", {
          style: {
            display: 'flex'
          }
        }), children, " ", /*#__PURE__*/_react.default.createElement(_spinner.default, {
          radius: 16,
          stroke: 2,
          color: "white"
        })));
      case 'dropdown':
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "".concat(_styles.default.button, " ").concat(className)
        }, /*#__PURE__*/_react.default.createElement(_dropdown.default, (0, _extends2.default)({
          menuClassName: menuClassName
        }, props), children));
      default:
        return /*#__PURE__*/_react.default.createElement("span", {
          className: "".concat(_styles.default.button)
        }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, props, {
          disableElevation: variant === 'contained'
        }), children));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderButton());
}
Button.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.shape({}).isRequired,
  /** icon may be Font-awesome <Icon> Element, Font-awesome classname string, or svg */
  icon: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  /** icon size: small, medium, or large */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  buttonType: _propTypes.default.oneOf(['btn', 'loading', 'dropdown']),
  variant: _propTypes.default.oneOf(['text', 'contained', 'outlined'])
};
Button.defaultProps = {
  className: '',
  icon: null,
  size: 'medium',
  buttonType: 'btn',
  variant: 'contained'
};
var _default = Button;
exports.default = _default;